export const TextFieldChecks = (type,value)=>{
    switch(type){
        case 'number':
            var regex=/^[0-9]+$/;
            if(value.length){
                if (value[value.length-1].match(regex))
                {
                    return false
                }
            }
            return true
        case 'text':
            var regex=/^[0-9]+$/;
            if(value === ""){
                return false
            }
            if(value.length){
                if (value[value.length-1].match(regex))
                {
                    return false
                }
            }
            return true
        case 'passport':
            if(value.length > 7 && value.length<20){
                return true
            }else{
                return false
            }
        case 'name':
            if (
                !/^[ a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ]*$/.test(value)
            ) {
                return false
            } else {
                return true
            }
      
            break
        default:
            break
    }
}